import angular from 'angular';
import template from "./login.html";
import controller from "./login.controller";

let loginComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

let loginModule = angular.module('login', []) .config(($stateProvider) =>
{
  "ngInject";
  // $stateProvider
  //   .state('login', {
  //     url: '/login',
  //     template: '<login></login>',
  //     onEnter: function($http, $rootScope, $state, $location, AuthenticationService) {
  //       AuthenticationService.isAuthenticated().then(function (response) {
  //           $state.go('admin');
  //       });
  //     },
  //     params: {
  //       loginErrorCode: ''
  //     }
  //   });
})
.component('login', loginComponent);

export default loginModule;



// WEBPACK FOOTER //
// ./client/pages/login/login.js